import { render, staticRenderFns } from "./OnboardingStatus.vue?vue&type=template&id=1327d6ee&"
import script from "./OnboardingStatus.vue?vue&type=script&lang=js&"
export * from "./OnboardingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports